import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/utils/Stream';

import getUserInfo from "../../common/util/getUserInfo";
import distributeRatio from '../../common/util/distributeRatio';
import InfoDistributesSuccessModal from "./InfoDistributesSuccessModal";
import estimateIncome from '../../common/util/estimateIncome';

export default class ItemDistributeModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.infoBaseData = this.attrs.infoBaseData;
    this.callback = this.attrs.callback;
    this.infoDetailsData = this.infoBaseData.u2diDetailsData();
    this.itemID = this.infoBaseData.id();
    this.itemSN = this.infoBaseData.sn();

    // const info_zcxx = JSON.parse(this.infoDetailsData.zcxx());
    // this.itemCannotEstimate = info_zcxx.option_lzxz==="ys";

    const userInfo = getUserInfo(app.session.user.id());
    this.realName = userInfo.zsxm();
  }
  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.title-distribute');
  }

  content() {
    const infoEstimateIncome = estimateIncome(this.infoBaseData,this.infoDetailsData);
    let userType = this.infoBaseData.userType();

    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="u2diItemQueryContainier Form">
          <div style="padding-top: 20px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-sn')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <div className="u2diOptionsAdjustItem">
                {this.itemSN}
              </div>
            </div>
          </div>

          <div style="padding-top: 20px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-distributor-ratio')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <div className="u2diOptionsAdjustItem">
                {distributeRatio(userType)}
              </div>
            </div>
          </div>

          <div style="padding-top: 20px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-deal-income')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <span style="color: gray;margin-right: 5px;font-size: 12px;">约</span>
                  <span style="font-size:16px">
                    {infoEstimateIncome+" "+app.translator.trans('ziven-u2di.lib.unit-10k')}
                  </span>
                  <span style="color: gray;margin-left: 10px;font-size: 12px;">估算值仅参考</span>
                </div>
            </div>
          </div>

          <div style="padding-top: 20px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-distributor')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <div className="u2diOptionsAdjustItem">
                {this.realName}
              </div>
            </div>
          </div>

          <div style="text-align: center;padding-top: 20px;">
            {Button.component({
                style:"min-width:66px;",
                disabled: this.loading,
                type: 'submit',
                className: 'Button Button--primary',
              },
              app.translator.trans('ziven-u2di.lib.submit')
            )}
            &nbsp;
            {Button.component({
                style:"min-width:66px;",
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();
    this.loading = true;

    const _this = this;
    const submitData = {
      itemID:this.itemID,
    };

    $(".Modal-close").hide();
    
    app.store
        .createRecord("u2diInfoDistributes")
        .save(submitData)
        .then((result) => {
            app.modal.show(InfoDistributesSuccessModal);
            $(window).trigger('u2diDistributeAdd');

            setTimeout(function(){
              _this.callback();
            },100);
          }
        )
        .catch((e) => {
          this.loading = false;
        });

  }
}